export default "__VITE_ASSET__dHDMO0dtqgUZCr4yokXpXA__"